import React, { useState, useRef, useEffect } from 'react';
import { MdCalendarToday, MdChevronRight, MdCheck } from 'react-icons/md';

const OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7', label: 'Last 7 Days' },
  { value: 'last30', label: 'Last 30 Days' },
  { value: 'thisMonth', label: 'This Month' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'custom', label: 'Custom Range' },
];

export default function GlobalDateFilter({ filter, fromDate, toDate, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [localFilter, setLocalFilter] = useState(filter);
  const [customFrom, setCustomFrom] = useState(fromDate || '');
  const [customTo, setCustomTo] = useState(toDate || '');
  
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setIsOpen(false);
        setLocalFilter(filter); // reset on close if not applied
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, filter]);

  const handleSelect = (opt) => {
    setLocalFilter(opt);
    if (opt !== 'custom') {
      onChange(opt, '', '');
      setIsOpen(false);
    }
  };

  const handleApplyCustom = () => {
    if (customFrom && customTo) {
      onChange('custom', customFrom, customTo);
      setIsOpen(false);
    }
  };

  const currentLabel = OPTIONS.find(o => o.value === filter)?.label || 'Today';

  return (
    <div className="global-date-filter" ref={popoverRef}>
      <button className="date-filter-trigger" onClick={() => setIsOpen(!isOpen)}>
        <MdCalendarToday className="icon" />
        <span className="label">{currentLabel}</span>
        {filter === 'custom' && customFrom && customTo && (
          <span className="custom-dates">({customFrom} - {customTo})</span>
        )}
        <MdChevronRight className={`caret ${isOpen ? 'open' : ''}`} />
      </button>

      {isOpen && (
        <div className="date-filter-popover">
          <div className="preset-options">
            {OPTIONS.map(opt => (
              <div 
                key={opt.value} 
                className={`preset-option ${localFilter === opt.value ? 'active' : ''}`}
                onClick={() => handleSelect(opt.value)}
              >
                <span>{opt.label}</span>
                {localFilter === opt.value && <MdCheck className="check-icon" />}
              </div>
            ))}
          </div>

          {localFilter === 'custom' && (
            <div className="custom-range-picker">
              <div className="picker-row">
                <label>From</label>
                <input 
                  type="date" 
                  value={customFrom} 
                  onChange={(e) => setCustomFrom(e.target.value)} 
                />
              </div>
              <div className="picker-row">
                <label>To</label>
                <input 
                  type="date" 
                  value={customTo} 
                  onChange={(e) => setCustomTo(e.target.value)} 
                />
              </div>
              <div className="picker-actions">
                <button className="btn btn-ghost btn-sm" onClick={() => { setIsOpen(false); setLocalFilter(filter); }}>Cancel</button>
                <button 
                  className="btn btn-primary btn-sm" 
                  onClick={handleApplyCustom}
                  disabled={!customFrom || !customTo}
                >
                  Apply
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
